export default __webpack_public_path__ + "fc396f71f5e1eac1053c77f4373c8b33.png";